











import { Component, Prop, Vue } from 'vue-property-decorator';
import { Book } from '@/types'

@Component
export default class Books extends Vue {
  @Prop() books!: Array<Book>;
}
